import moment from "moment";

import { CROP_TYPE_FCPO, CropFCPO } from "models";

export const NEW_CROP = (cropType: CROP_TYPE_FCPO, seedingStartDate?: string, harvestEndDate?: string, cropName?: string): CropFCPO => ({
  id: "",
  cropId: "",
  cropName: cropName ?? "",
  year: cropType === CROP_TYPE_FCPO.MAIN ? moment(harvestEndDate).year() : moment(seedingStartDate).year(),
  cropType,
  seedingStartDate: seedingStartDate ?? "",
  seedingEndDate: seedingStartDate ?? "",
  harvestStartDate: harvestEndDate ?? "",
  harvestEndDate: harvestEndDate ?? "",
  seedingPracticeType: "",
  hasResidue: null,
  isConfirmed: false,
  yieldPerHa: null,
  yieldPerHaUnit: null,
  translationSlug: "",
  seedingVerificationStatus: null,
  fallbackDates: {
    seedingStartDate: seedingStartDate ?? null,
    harvestEndDate: harvestEndDate ?? null,
  },
});

export const CROP = "crop";

export const FARM_YEAR_START = "10/01/";
export const FARM_YEAR_END = "09/30/";
export const CALENDAR_YEAR_START = "01/01/";
export const CALENDAR_YEAR_END = "12/31/";
